(function(window){
	window.Broccoli = require('./apis/broccoli-client.js');
})(window);
